const residenceTypes = [
  {
    value: 'Own',
    text:  'Própria',
  },
  {
    value: 'Rent',
    text:  'Alugada',
  },
  {
    value: 'Family',
    text:  'Familiares',
  },
];
export default residenceTypes;
